/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Button, Icon } from '@wordpress/components';

/**
 * Internal dependencies
 */
import { _getUrlParams } from '../../functions';
import { proIcon } from '../../assets/icons';

const PluginVersion = ({ type, version }) => (
	<>
		<div className={`rv-${type}-version`}>
			<span className="rv-version">
				{__(version, 'riovizual')} <span>{__(type, 'riovizual')}</span>
			</span>
		</div>
		<span className="v-line"></span>
	</>
);

const Navigation = ( {menus} ) => {
	return <nav className="navbar">
		<ul>
			{ menus.map(({ name, url }, index) => {
				const isActivePage = () => {
					const currentParams = _getUrlParams();
					const checkParams = ( key ) => currentParams[key] === url.split(key + '=')[1];

					if( currentParams.path ) {
						return checkParams('path');
					} else {
						return checkParams('page');
					}
				}

				return <li key={index}>
					<a href={url} style={ isActivePage() ? { background: '#f6f7f9' } : {}}>
						{name}
					</a>
				</li>
			})}
		</ul>
	</nav>
}

export default function Header() {
	const { version, pro_version, isActive, dashboardData } = rv_dashboard_data;
	const isLicensed = dashboardData?.license_data?.status || 'deactive';

	const $baseURL = `admin.php?page=riovizual`;

	const menuItems = [
		{ name: __('Dashboard', 'riovizual'), url: `${$baseURL}` },
		{ name: __('Blocks', 'riovizual'), url: `${$baseURL}&path=blocks` },
		{ name: __('Tables', 'riovizual'), url: 'admin.php?page=riovizualTables' },
		isActive
			? { name: __('License', 'riovizual'), url: `${$baseURL}&path=license` }
			: { name: __('Free vs Pro', 'riovizual'), url: `${$baseURL}&path=freeVsPro` },
	];

	return (
		<>
			{/* main header */}
			<header className="rv_dash-header">
				<div className="rv_dash-header-container">
					<div className="logo">
						<img
							src="https://riovizual.com/wp-content/uploads/2024/05/Riovizual-Logo.png"
							alt={__('rio vizual logo', 'riovizual')}
						/>
					</div>

					<Navigation menus={ menuItems } />

					<div className="info">
						<PluginVersion type="core" version={version} />
						{isActive ? (
							<>
								<PluginVersion type="pro" version={pro_version} />
								<span className={`rv-${isLicensed !== 'active' ? 'unlicensed' : 'licensed'}-tag`}>
									{__(isLicensed !== 'active' ? 'Unlicensed' : 'Licensed', 'riovizual')}
								</span>
							</>
						) : (
							<Button
								href="https://riovizual.com/pricing/"
								className="rv_dash-btn rv-btn-filled pro-icon"
								variant="link"
								target='_blank'
							>
								<Icon icon={proIcon} width={18} height={18}/>
								{__('Upgrade to Pro', 'riovizual')}
							</Button>
						)}
					</div>
				</div>
			</header>
		</>
	);
}
